import React, { useState, useEffect } from "react";
const ViewHistoryPopup = ({ onClose,detaildata }) => {
  const [popupData, setPopupData] = useState([]);
  const [popupDataTable, setPopupDataTable] = useState([]);
  const formatDateList = (dateString) => {
    const [datePart] = dateString.split(" "); // Extract the date portion
    const [day, month, year] = datePart.split("/"); // Split into day, month, and year
    return `${day}/${month}/${year}`;
  };
    const [isLoading, setIsLoading] = useState(false);
  


  return (
    <div className="fixed px-4 md:px-0 inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-full max-w-4xl p-6 max-h-[90vh]  overflow-y-auto rounded-lg shadow-lg relative">
        {/* Header */}
        <div className="relative pb-4 mb-4">
  {/* Close Button - Positioned Top Right */}
  <button
    onClick={onClose}
    className="absolute top-0 right-4 text-gray-500 hover:text-black text-lg"
  >
    <img src="/add.svg" alt="Close" className="w-6 h-6 md:w-8 md:h-8" />
  </button>

  {/* Centered Headings */}
  <div className="flex flex-col items-center text-center w-full">
    <h2 className="text-sm md:text-xl font-medium break-words">
    {formatDateList(detaildata.created_at)}
    </h2>
    <h2 className="text-sm md:text-xl font-medium break-words">
      Change Done By: <span className="text-[#8C8C8C]">{detaildata.created_by_name}</span>
    </h2>
  </div>
</div>


<div className="overflow-x-auto max-h-[70vh]  font-medium overflow-y-auto mb-6">
            <table className="table-auto w-full border rounded border-gray-300">
              <thead>
                <tr className="text-[#005A9C] text-left text-xs">
                  <th className="px-4 py-2 border bg-[#FDF4FF]">No</th>
                  <th className="px-4 py-2 border bg-[#ECFFEE]">Security</th>
                  <th className="px-4 py-2 border bg-[#ECFFEE]">New W(%)</th>
                  <th className="px-4 py-2 border bg-[#ECFFEE]">Old W(%)</th>
                </tr>
              </thead>
              {isLoading ? (
                <tbody className="shimmer-container-list ">
                  {[...Array(5)].map((_, rowIndex) => (
                    <tr key={rowIndex} className="shimmer-row-list">
                      {[...Array(4)].map((_, colIndex) => (
                        <td key={colIndex} className="shimmer-cell-list">
                          <div className="shimmer-loader"></div>
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="text-sm">
                     {detaildata.allocation_changes.stock.length > 0 ? (
                    detaildata.allocation_changes.stock.map((row,index) => (
                    <tr>
                      <td className="px-4 py-2 border  bg-[#FDF4FF]">
                      {(index + 1)
                                                    .toString()
                                                    .padStart(2, "0")}
                      </td>
                      <td className="px-4 py-2 border">{row.asx_code}</td>
                      <td className="px-4 py-2 border">{row.new_percentage.toFixed(2)}%</td>
                      <td className="px-4 py-2 border">{row.old_percentage.toFixed(2)}%</td>
                    </tr>
                  ))
                  ) : (
                    <tr>
                      <td className="text-center py-4" colSpan="7">
                        No results found
                      </td>
                    </tr>
                  )}   
                </tbody>
              )}
            </table>
          </div>
        {/* Table */}
        {/* {popupDataTable && (
          <div className="overflow-x-auto max-h-[70vh]  font-medium overflow-y-auto mb-6">
            <table className="table-auto w-full border rounded border-gray-300">
              <thead>
                <tr className="text-[#005A9C] text-xs">
                  <th className="px-4 py-2 border bg-[#FDF4FF]">No</th>
                  <th className="px-4 py-2 border">Client Name</th>
                  <th className="px-4 py-2 border">Client ID</th>
                  <th className="px-4 py-2 border">Product Name</th>

                  <th className="px-4 py-2 border">
                    No of Shares {popupData.id}
                  </th>

                  <th className="px-4 py-2 border">Cash Account</th>
                  <th className="px-4 py-2 border">Time of Request</th>
                </tr>
              </thead>
              {isLoading ? (
                <tbody className="shimmer-container-list ">
                  {[...Array(5)].map((_, rowIndex) => (
                    <tr key={rowIndex} className="shimmer-row-list">
                      {[...Array(7)].map((_, colIndex) => (
                        <td key={colIndex} className="shimmer-cell-list">
                          <div className="shimmer-loader"></div>
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="text-sm">
                  {popupDataTable.map((row, index) => (
                    <tr key={index}>
                      <td className="px-4 py-2 border  bg-[#FDF4FF]">
                        {String(index).padStart(2, "0")}
                      </td>
                      <td className="px-4 py-2 border">{row.user_name}</td>
                      <td className="px-4 py-2 border">{row.client_id}</td>
                      <td className="px-4 py-2 border">{row.product_name}</td>
                      <td className="px-4 py-2 border">
                        {row.purchase_quantity}
                      </td>
                      <td className="px-4 py-2 border">
                        {(row.cash_account == null ? 0 : row.cash_account)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </td>
                      <td className="px-4 py-2 border">
                        {formatDate(row.requested_at)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
            </table>
          </div>
        )} */}
      </div>
    </div>
  );
};

export default ViewHistoryPopup;
